<template>
  <div>
      <h2 class="mt-5">Upload Expense</h2>
     <ExcelVue :sheet="sampleExcel" :fname="filename"/>
  </div>
</template>

<script>
import ExcelVue from "@/components/ExcelExpensePnl.vue";

export default {
  components: {
    ExcelVue
  },
  data() {
    return {
      file: null, 
      filename:"FormExpensePnl.xlsx",
      sampleExcel:[{ 
                    name: "SheetOne",  
                    data: [ 
                            {
                              "Tanggal": "2021-01-01",
                              "ph": "PH Jember",
                              "incentive_hero": -16045569,
                              "phl": -6821630,
                              "lm_cost_ats_outbound": -10323000,
                              "parking_fm_lm": 0,
                              "linehaul_cost_of_delivery": -16093465,
                              "feeder_linehaul_by_paxel": 0,
                              "other_cost_of_delivery": 0,
                              "pp_cost": 0,
                              "equipment_hero": 0,
                              "consumables_hero": -1979242,
                              "salaries_benefit": -15812110,
                              "bpjs": -1137630,
                              "medical": 0,
                              "utilities": -1861914,
                              "rental_ph": 0,
                              "renovation": 0,
                              "rental_pp": -5000000,
                              "supplies": 0,
                              "slaims": -192500,
                              "ph_consumables": -979750,
                              "ph_maintenance": -240000,
                              "office_equipment": 0,
                              "marketing": 0,
                              "professional Fee": 0,
                              "others": -585000,
                              "class": null,
                              "is_delete":false
                            },
                            {
                              "Tanggal": "2021-01-02",
                              "ph": "PH Medan",
                              "incentive_hero": -12543920,
                              "phl": -71297265,
                              "lm_cost_ats_outbound": 0,
                              "parking_fm_lm": 0,
                              "linehaul_cost_of_delivery": 0,
                              "feeder_linehaul_by_paxel": 0,
                              "other_cost_of_delivery": -27509000,
                              "pp_cost": 0,
                              "equipment_hero": 0,
                              "consumables_hero": -10900200,
                              "salaries_benefit": -2080959,
                              "BPJS": -1965000,
                              "Medical": 0,
                              "Utilities": -1475000,
                              "rental_ph": -3888888,
                              "Renovation": 0,
                              "Rental PP": -500000,
                              "Supplies": 0,
                              "Claims": -1419050,
                              "ph_consumables": -1432100,
                              "ph_maintenance": 0,
                              "Office Equipment": -3080900,
                              "Marketing": 0,
                              "Professional Fee": 0,
                              "Others": 0,
                              "Class": null,
                              "is_delete":false
                            },
                          ] 
                    }],
    };
  },
  methods: {
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    test(){}

  },
  mounted(){
    
  }
 
};
</script>
<style scoped>
input[type="file"] {
    width: 50%;
    border: 1px solid black;
    padding: 5px 25px;
    border-radius: 5px;
}
</style>
